import React, { Component } from 'react'
import { connect } from 'react-redux'
import cn from 'classnames'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import Psfs from 'lib/psfs/Psfs'
import {
  fetchLocusLevelEventValues,
  fetchLocusList,
} from 'reducers/logbookForm/reducer'
import { formattValues } from 'helpers/logbookForm'
import { TYPE_INPUT_BOOLEAN } from 'helpers/logbook'
import MasterEventField from './MasterEvent'

class LocusList extends Component {
  shouldComponentUpdate(nextProps) {
    const {
      activeDate,
      activeForm,
      activeLocusGroup,
      locusList,
      fetchLocusList,
    } = this.props
    const {
      activeSite: nextSite,
      activeDate: nextDate,
      activeForm: nextForm,
      activeLocusGroup: nextLocusGroup,
      locusList: nextLocusList,
    } = nextProps

    if (
      nextForm &&
      nextForm.needs_locus &&
      ((activeForm !== nextForm && !nextForm.needs_locus_group) ||
        (nextLocusGroup && nextLocusGroup !== activeLocusGroup))
    ) {
      const psfs = new Psfs()
      psfs.addFields(['id', 'containerName']).addFilter('site', nextSite)

      if (nextForm.needs_locus_group) {
        psfs.addFilter('locusGroup', nextLocusGroup.id)
      }

      fetchLocusList({ psfs })

      return false
    }

    if (
      (nextLocusList !== locusList || nextDate !== activeDate) &&
      nextLocusGroup &&
      nextForm.needs_locus &&
      nextForm.events.length === 1
    ) {
      this.fetchLocusLevelEventValues(nextProps)

      return false
    }

    return true
  }

  onItemClick = e => {
    const { onItemClick, locusList } = this.props

    if (typeof onItemClick === 'function') {
      onItemClick(locusList.get(e.currentTarget.dataset.index))
    }
  }

  fetchLocusLevelEventValues = props => {
    const {
      activeLocusGroup,
      activeForm,
      activeDate,
      locusList,
      fetchLocusLevelEventValues,
    } = props

    fetchLocusLevelEventValues({
      params: {
        form: activeForm.id,
        date: activeDate.utc().format('YYYY-MM-DD'),
        event: activeForm.events[0].id,
        locuses: locusList
          .map(item => ({
            locus_group: activeLocusGroup.id,
            locus: item.id,
          }))
          .toArray(),
      },
    })
  }

  render() {
    if (!this.props.isShow) {
      return null
    }

    const {
      activeItem,
      activeForm,
      activeLocusGroup,
      activeAllEvents,
      activeEvent,
      onEventValueChange,
      onEventClick,
    } = this.props
    const locusList = this.props.locusList.toArray()
    const locusEventValues = formattValues(
      this.props.locusEventValues.toArray(),
      'locus_id',
    )

    return (
      <List component="div" disablePadding className="lbf-list">
        {locusList.map((item, index) => {
          const { events } = activeForm
          const isLastLevelList = Array.isArray(events) && events.length === 1
          const hasSlaveEvents =
            isLastLevelList && Array.isArray(events[0].slaves)
          const isEventOpen = activeEvent === item.id
          const clickHandler = hasSlaveEvents
            ? e => onEventClick(e, item.id)
            : null
          const onClick =
            !isLastLevelList || hasSlaveEvents ? this.onItemClick : clickHandler
          const selected = activeItem && activeItem.id === item.id

          return (
            <ListItem
              button
              key={index}
              data-index={index}
              onClick={onClick}
              className={cn('lbf-list-item', {
                'lbf-event-boolean':
                  TYPE_INPUT_BOOLEAN === (isLastLevelList && events[0].type),
                'lbf-event-item': !isLastLevelList || hasSlaveEvents,
                active: hasSlaveEvents && (isEventOpen || activeAllEvents),
                selected,
              })}>
              <ListItemText primary={item.containerName} />
              {isLastLevelList && !hasSlaveEvents && (
                <MasterEventField
                  index={index}
                  isEventOpen={isEventOpen || activeAllEvents}
                  hideTitle
                  eventInfo={{
                    ...events[0],
                    ...locusEventValues[item.id],
                    activeForm,
                    activeLocusGroup,
                    activeLocus: item,
                  }}
                  onEventValueChange={onEventValueChange}
                  updateValuesList={() =>
                    this.fetchLocusLevelEventValues(this.props)
                  }
                />
              )}
            </ListItem>
          )
        })}
      </List>
    )
  }
}

export default connect(
  state => ({
    activeSite: state.getIn(['profile', 'siteId']),
    activeDate: state.getIn(['logbookForm', 'activeDate']),
    locusList: state.getIn(['logbookForm', 'locusList']),
    locusEventValues: state.getIn(['logbookForm', 'locusEventValues']),
  }),
  {
    fetchLocusList,
    fetchLocusLevelEventValues,
  },
)(LocusList)
